import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconFlipVertically32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconFlipVertically32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M13.007 25v2H9.003a4 4 0 0 1-3.9-4.888l3.188-14A4 4 0 0 1 12.191 5h.816v2h-.816a2 2 0 0 0-1.95 1.556l-3.188 14A2 2 0 0 0 9.003 25zm9.99 2h-3.985v-2h3.985a2 2 0 0 0 1.95-2.444l-3.188-14A2 2 0 0 0 19.809 7h-.797V5h.797a4 4 0 0 1 3.9 3.112l3.188 14a4 4 0 0 1-3.9 4.888M17 4a1 1 0 1 0-2 0v24a1 1 0 1 0 2 0z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconFlipVertically32);
